import { Component, computed, input, OnInit, output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthorizationService } from '../../../core/auth/authorization.service';
import { APP_BRAND, NAVIGATION_ITEMS, type NavigationItem } from '../../../core/config';
import { Auth } from '../../../core/services/auth';
import { Language } from '../../../core/services/language';
import { LanguageSwitcher } from '../../ui';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, LanguageSwitcher],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {
  readonly brand = APP_BRAND;
  readonly collapsed = input(false);
  readonly isMobile = input(false);
  readonly isMobileOpen = input(false);

  readonly toggleCollapse = output<void>();
  readonly closeMobile = output<void>();
  readonly navId = 'app-sidebar-navigation';

  readonly items = computed(() =>
    NAVIGATION_ITEMS
      .filter((item) => this.authorization.isAllowed(item.permission))
      .map((item) => ({
        ...item,
        label: this.language.t(item.labelKey),
      })),
  );

  constructor(
    private readonly auth: Auth,
    private readonly authorization: AuthorizationService,
    public language: Language,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    void this.authorization.ensureLoaded().catch(() => undefined);
  }

  async onLogout() {
    this.closeMobile.emit();
    await this.auth.logout();
    await this.router.navigateByUrl('/login');
  }

  getToggleLabel() {
    return this.collapsed() ? 'Expand navigation' : 'Collapse navigation';
  }

  isLogoutItem(item: NavigationItem) {
    return item.key === 'logout';
  }
}
